export default "__VITE_ASSET__a0f7e8ee__"